import 'date-fns'
import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers'
import { IconButton, FormControl, InputLabel, Select, MenuItem, Paper } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

import { SearchInput } from 'components'

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '42px',
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1)
  },
  spacer: {
    flexGrow: 1
  },
  date: {
    borderRadius: '4px',
    alignItems: 'center',
    padding: theme.spacing(0.5, 1),
    display: 'flex',
    backgroundColor: '#FFF',
    marginLeft: theme.spacing(2)
  },
  starSelect: {
    marginLeft: theme.spacing(2),
    minWidth: 150,
    backgroundColor: '#FFF'
  }
}))

const ExToolbar = ({
  className,
  onSearch,
  startDate,
  endDate,
  star,
  isShow,
  onChangeStar,
  onChangeIsShow,
  onChangeStartDate,
  onChangeEndDate,
  onClearDate,
  ...rest
}) => {
  const classes = useStyles()

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <SearchInput
          placeholder="Cari produk / agen"
          onChange={onSearch}
        />

        <FormControl className={classes.starSelect} variant="outlined" size="small">
          <Select
            labelId="star-filter-label"
            id="star-filter"
            value={star || ''}
            onChange={onChangeStar}
            style={{ 'padding-top': '5px', 'padding-bottom': '5px' }}
            label="Bintang"
            displayEmpty
            renderValue={(selected) => {
              if (!selected) {
                return 'Semua Bintang'
              }
              return `${selected} Bintang`
            }}
          >
            <MenuItem value="">Semua Bintang</MenuItem>
            <MenuItem value={5}>5 Bintang</MenuItem>
            <MenuItem value={4}>4 Bintang</MenuItem>
            <MenuItem value={3}>3 Bintang</MenuItem>
            <MenuItem value={2}>2 Bintang</MenuItem>
            <MenuItem value={1}>1 Bintang</MenuItem>
          </Select>
        </FormControl>

        <FormControl className={classes.starSelect} variant="outlined" size="small">
          <Select
            labelId="is-show-filter-label"
            id="is-show-filter"
            value={isShow !== undefined && isShow !== null ? isShow : ''}
            onChange={onChangeIsShow}
            style={{ 'padding-top': '5px', 'padding-bottom': '5px' }}
            label="Status"
            displayEmpty
            renderValue={(selected) => {
              if (selected === '1' || selected === 1) {
                return 'Tampil'
              }
              if (selected === '0' || selected === 0) {
                return 'Sembunyi'
              }
              return 'Semua Tampilkan'
            }}
          >
            <MenuItem value="">Semua Tampilkan</MenuItem>
            <MenuItem value="1">Tampil</MenuItem>
            <MenuItem value="0">Sembunyi</MenuItem>
          </Select>
        </FormControl>


        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Paper className={classes.date}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="dd/MM/yyyy"
              id="start-date"
              placeholder="Tanggal Mulai"
              style={{ 'padding-top': '5px', 'padding-bottom': '5px' }}
              value={startDate}
              InputProps={{ disableUnderline: true }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              error={false}
              helperText={null}
              onChange={onChangeStartDate}
            />
          </Paper>

          <Paper className={classes.date}>
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="dd/MM/yyyy"
              id="end-date"
              placeholder="Tanggal Akhir"
              style={{ 'padding-top': '5px', 'padding-bottom': '5px' }}
              value={endDate}
              InputProps={{ disableUnderline: true }}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              error={false}
              helperText={null}
              onChange={onChangeEndDate}
            />
          </Paper>
          <IconButton
            onClick={onClearDate}
            style={{ 'margin-left': '15px', 'margin-right': '15px' }}
            color="inherit"
          >
            <CloseIcon />
          </IconButton>
        </MuiPickersUtilsProvider>
      </div>
    </div>
  )
}


ExToolbar.propTypes = {
  className: PropTypes.string,
  onSearch: PropTypes.func,
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  star: PropTypes.any,
  isShow: PropTypes.any,
  onChangeStar: PropTypes.func,
  onChangeIsShow: PropTypes.func,
  onChangeStartDate: PropTypes.func,
  onChangeEndDate: PropTypes.func,
  onClearDate: PropTypes.func
}

export default ExToolbar

